/* eslint-disable react/prop-types */
import React from 'react'
import { withTranslation } from 'react-i18next'

import ChallengeDetailCard from '../subcomponents/ChallengeDetailCard'

import './ChallengeShow.scss'

class ChallengeShow extends React.Component {
  render() {
    const {
      selectedChallenge,
      returnToIndex,
      goToEdit,
      goToDestroy,
      t,
    } = this.props
    return (
      <div id='ChallengeShow'>
        <div className='return-button-container'>
          <button className='return-challenge-button' onClick={returnToIndex}>
            {t('challenges.common.backToChallenges')}
          </button>
        </div>
        <ChallengeDetailCard
          selectedChallenge={selectedChallenge}
          goToEdit={goToEdit}
          goToDestroy={goToDestroy}
        />
      </div>
    )
  }
}

export default withTranslation()(ChallengeShow)
